import React from 'react';
import axios from 'axios';
import {useAuthentication, useAuthenticationToken} from "@careers-wales/react-components";
function useDecisionMakingApi(env) {

  const { isAuthenticated} = useAuthentication();
  const { callWithToken } = useAuthenticationToken();

  const endpoints = {
    getQuestions: env.REACT_APP_DECISION_MAKING_API_GET_QUESTIONS || `${env.REACT_APP_ENV}/decision-making-quiz-api/api/v1/get-questions`,
    submitQuiz: env.REACT_APP_DECISION_MAKING_API_SUBMIT_QUIZ || `${env.REACT_APP_ENV}/decision-making-quiz-api/api/v1/submit-quiz`,
    quizResults: env.REACT_APP_DECISION_MAKING_API_QUIZ_RESULTS || `${env.REACT_APP_ENV}/decision-making-quiz-api/api/v1/quiz-results`,
  };

  function getEndpoint(name) {
    return endpoints[name];
  }



  async function quizResults(language, successCallback, errorCallback) {
    if (isAuthenticated()) {
      return callWithToken().then((response) => {
        return axios
            .get(`${endpoints.quizResults}`, {
              headers: {
                'content-type': 'application/json',
                'Accept-Language': language,
                'Authorization': 'Bearer ' + response.idToken
              }
            })
            .then((response) => {
              successCallback(response);
              return response;
            })
            .catch((error) => {
              errorCallback(error);
              return error.response;
            });
      });
    } else {
      errorCallback({});
      return Promise.resolve();
    }
  }

  async function getQuestions(language, successCallback, errorCallback) {
    return axios
      .get(`${endpoints.getQuestions}`, {
        headers: {
          'content-type': 'application/json',
          'Accept-Language': language
        }
      })
      .then((response) => {
        successCallback(response);

        return response;
      })
      .catch((error) => {
        errorCallback(error);

        return error.response;
      });
  }

  async function submitQuiz(payload, language, successCallback, errorCallback) {

    if (isAuthenticated()) {
      return callWithToken().then((response) => {
        return axiosSubmitQuiz(payload, language, response.idToken, successCallback, errorCallback);
      });
    } else {
      return axiosSubmitQuiz(payload, language, false, successCallback, errorCallback);
    }

  }


    function axiosSubmitQuiz(data, language,idToken = false, successCallback, errorCallback) {

      let headers = {
        'Accept-Language': language,
        'content-type': 'application/json'
      };

      if (idToken) {
        headers['Authorization'] = 'Bearer ' + idToken;
      }

      return axios
          .post(`${endpoints.submitQuiz}`, data, {
            headers: headers
          })
          .then((response) => {
            if (typeof successCallback !== "undefined") {
              successCallback(response);
            }
            return response;
          })
          .catch((error) => {
            if (typeof errorCallback !== "undefined") {
              errorCallback(error);
            }
            return error.response;
          });

    }



  return {
    getEndpoint,
    getQuestions,
    submitQuiz,
    quizResults
  };
}

export default useDecisionMakingApi;
